var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.316 7 1.486 8.8H11.6l3.465 7.207L18.32 8.8h11.987l-.831-1.8H17.698l-2.633 6.028L12.363 7H2.316zm8.522 2.84H1.485L1 11.712h8.383l5.682 12.68 5.404-12.679h10.53l-.693-1.87H19.014l-3.95 9.285-4.226-9.284zm11.155 10.948v1.108h1.04v-1.108h.83v1.108h.763V20.58c.6-.046 1.898-.25 2.286-.693.485-.554.693-1.732.277-2.494-.333-.61-.786-.809-.97-.832.23-.16.692-.65.692-1.315 0-.832-.554-1.109-1.04-1.317a7.26 7.26 0 0 0-1.108-.346v-1.386h-.9v1.178h-.762v-1.178h-.97v1.178l-.278.07h-1.593v.97c.37.023 1.123.124 1.179.346.054.221.022 2.864-.001 4.157.045.185.04.554-.348.554h-.762v1.11h1.663v.208zm3.118-5.335c0 .776-1.339.877-2.008.831v-1.663c.67-.045 2.009.057 2.009.833zm-2.008 2.286v1.593h1.8c.232-.116.694-.485.694-1.04 0-.554-.462-.785-.693-.831h-1.801v.277z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbit);
export default __webpack_public_path__ + "static/media/VBIT.0e47b85173478ff4bfa9744d1e885ef6.svg";
export { ForwardRef as ReactComponent };